import * as React from 'react';
import { useRouter } from 'next/router';

import { BreakpointFlag, FixedRatio, SchemalessResponsiveImage } from '@packages/ui';

import type { DyImages } from '../types';
import { SmartLink } from '../../SmartLink';
import { useGetDyImageSources } from '../utils/useGetDyImageSources';
import { combineLinkQueryWithUrl } from './utils';
export interface DYHeroBannerProps {
  data: {
    images: DyImages;
    linkOrQuery: string;
  };
  onClick: VoidFunction;
}

export const DYHeroBanner: React.FC<DYHeroBannerProps> = ({ data, onClick }) => {
  const { asPath } = useRouter();
  const { images, linkOrQuery } = data;

  const updatedLinkUrl = combineLinkQueryWithUrl(linkOrQuery, asPath);
  const { desktop, tablet, mobile } = images;

  const { sources, cdnProvider } = useGetDyImageSources(images);
  const [mobileSrc, tabletSrc, desktopSrc] = sources;

  const mobileRatio = Number(mobile.height) / Number(mobile.width);
  const tabletRatio = Number(tablet.height) / Number(tablet.width);
  const desktopRatio = Number(desktop.height) / Number(desktop.width);

  return (
    <FixedRatio ratio={[mobileRatio, mobileRatio, tabletRatio, desktopRatio]}>
      <SmartLink target="_self" linkUrl={updatedLinkUrl}>
        <div onClick={onClick}>
          <SchemalessResponsiveImage
            cdnProvider={cdnProvider}
            mapping={{
              [BreakpointFlag.SM]: mobileSrc,
              [BreakpointFlag.MD]: tabletSrc,
              [BreakpointFlag.LG]: desktopSrc,
            }}
          />
        </div>
      </SmartLink>
    </FixedRatio>
  );
};
